module.exports = __webpack_public_path__ + "img/illustration-01.c17fb519.png";